import * as Client from '@/api';
const enums = {
    state: {
        enumList: {},
    },
    mutations: {
        SET_ENUM_LIST(state, payload) {
            state.enumList[payload.code] = payload.data || [];
        },
    },
    actions: {
        async getEnumList({ commit, getters }, code) {
        const enumList = getters.enumList;
            var list = enumList[code];
            if (list) {
                return list;
            }
            try {
                const data = await Client.getKeyValue(code);
                commit('SET_ENUM_LIST', { data, code });
                return getters.enumList[code];
            } catch (error) {
                // eslint-disable-next-line
                console.log('getEnumList error', error);
            }
        }
    }
};

export default enums;
